import { useInfiniteQuery } from "@tanstack/react-query";
import { getCoreAxiosInstance } from "../../api/CoreAxiosInstance";
import {
  ShadowRunsListResponseSchema,
  type RunListFilters,
  type ShadowRunsListResponse,
} from "../types";

const PAGE_SIZE = 25;

export function useShadowRunList(
  agentId: string,
  filters: RunListFilters,
) {
  return useInfiniteQuery<ShadowRunsListResponse, Error>({
    queryKey: ["shadowRunList", agentId, filters],
    queryFn: async ({ pageParam }) => {
      const instance = await getCoreAxiosInstance();
      const params: Record<string, string> = {
        limit: String(PAGE_SIZE),
        sortBy: filters.sortBy,
        sortDirection: filters.sortDirection,
      };
      if (pageParam) params.cursor = pageParam as string;
      if (filters.status.length > 0)
        params.status = filters.status.join(",");
      if (filters.dateFrom) params.dateFrom = filters.dateFrom;
      if (filters.dateTo) params.dateTo = filters.dateTo;

      const { data } = await instance.get(
        `/api/v1/agents/${agentId}/invocations`,
        { params },
      );
      return ShadowRunsListResponseSchema.parse(data);
    },
    getNextPageParam: (lastPage) => lastPage.nextPageCursor ?? undefined,
    initialPageParam: null as string | null,
    enabled: !!agentId,
    refetchInterval: (query) => {
      const pages = query.state.data?.pages;
      if (!pages) return false;
      const hasInFlight = pages.some((page) =>
        page.data.some(
          (item) => item.status === "running" || item.status === "pending",
        ),
      );
      return hasInFlight ? 5000 : false;
    },
  });
}
